import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import BrandBlogArticlePage from './BrandBlogArticlePage';

export default function BlogArticlePage() {
  return (
    <>
      <Navbar />
      <BrandBlogArticlePage
        publisher="樂律文化"
        brandName="樂律文化"
        englishName="LELYRIC"
      />
      <Footer />
    </>
  );
}
